import React, { useState } from 'react';
import { Button, Tag, Tooltip } from 'antd';
import { ApiOutlined, RightOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

/** the providers the create form offers, in the words it uses for them */
export const PROVIDER_LABELS: { [key: string]: string } = {
    openai: 'OpenAI',
    openai_assistant: 'OpenAI Assistant',
    anthropic: 'Anthropic',
    mistral: 'Mistral',
    azure: 'Azure',
    custom: 'Custom HTTP',
    xai: 'xAI',
    gemini: 'Google Gemini',
    cohere: 'Cohere',
    genai: 'Genai',
};

/**
 * One model under the shared column header: what it is called here, which model
 * that actually is, and whose it is — then a way to check it answers.
 *
 * The row opens the model. Testing the connection acts on it in place, so it
 * stops the click from reaching the row.
 */
const LLMModelRow = ({
    record,
    detailPath,
    onTest,
}: {
    record: any;
    detailPath: string;
    /** resolves once the test has answered, either way */
    onTest: (record: any) => Promise<void>;
}) => {
    const history = useHistory();
    const [testing, setTesting] = useState(false);
    const open = () => history.push(`${detailPath}/${record.id}`);

    const test = () => {
        setTesting(true);
        onTest(record).finally(() => setTesting(false));
    };

    return (
        <div
            className="llm-row"
            role="button"
            tabIndex={0}
            aria-label={`Open ${record.name}`}
            onClick={open}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    open();
                }
            }}
        >
            <Tooltip placement="topLeft" title={record.name}>
                <div className="llm-name">{record.name}</div>
            </Tooltip>

            <Tooltip placement="topLeft" title={record.model_name}>
                <div className="llm-cell" data-label="Model">{record.model_name || '—'}</div>
            </Tooltip>

            <div className="llm-cell" data-label="Provider">
                {record.provider
                    ? <Tag className="llm-provider">{PROVIDER_LABELS[record.provider] || record.provider}</Tag>
                    : '—'}
            </div>

            {/* eslint-disable-next-line */}
            <div
                className="llm-actions"
                role="presentation"
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Button size="small" icon={<ApiOutlined />} loading={testing} onClick={test}>
                    Test connection
                </Button>
            </div>

            <span className="llm-chevron" aria-hidden="true"><RightOutlined /></span>
        </div>
    );
};

export default LLMModelRow;
